module.exports = __webpack_public_path__ + "static/img/app_twill.c44241f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/app_twill.png
// module id = d8V4
// module chunks = 1